import {LOAD_CASE, LOAD_SETTLEMENTRATE, LOAD_SETTLEMENTRATEBANDS, LOAD_PURCHASEDETAILS} from "./actions";
import { ACEALERT } from "../../../../ace/redux/actions";



const initialState = {
	currentCase: {
		riskData : {
			riskScore : 
				null
		}
	},
	alertType : '',
	caseId: null,
	fillingName: "",
	market: "",
	excelFile: "",
	complaintFile: "",
	settlementRates: {},
	currentSettlementRate: {},
	currentSettlementRateBands: [{
			"settlementRateValue": 0,
			"settlementRateBandLabel": "Median Rule 10b-5 Ratio for Settled Claims",
			"settlementRate10Value":0,
			"settlementRate25Value":0,
			"settlementRateValue":0,
			"settlementRate75Value":0,
			"settlementRate90Value":0,
			"settlementRateMeanValue":0
		}]


};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case LOAD_CASE:
			return { ...state, 
				currentCase: action.basicDamages, 
				caseId: action.caseId,
				fillingName: action.basicDamages.fillingName,
				market: action.basicDamages.market,
				excelFile: action.basicDamages.excelFile, 
				complaintFile: action.basicDamages.complaintFile, 
				docketNumber: action.basicDamages.docketNumber};      
		case LOAD_SETTLEMENTRATE:
			return { ...state, currentSettlementRate: action.currentSettlementRate};
		case LOAD_SETTLEMENTRATEBANDS:
			return { ...state, currentSettlementRateBands: action.currentSettlementRateBands};
		case LOAD_PURCHASEDETAILS:
			return { ...state, purchaseTime: action.purchaseTime, purchaseType: action.purchaseType};
		case ACEALERT:
			return {...state,alertType:action.alertType}
		default:
			return state;
	}
	
};


export default reducer;



// WEBPACK FOOTER //
// ./src/components/DamageReports/BasicDamageReport/store/reducer.js